import Divider from "@mui/material/Divider";
import ErrorIcon from "@mui/icons-material/Error";
import { Button, Chip, Grid } from "@mui/material";

import ProtectedRoute from "../auth/ProtectedRoute";

const NotFound = () => (
  <ProtectedRoute>
    <Grid direction="column" alignItems="center" justifyContent="center">
      <Chip color="error" label="404: Page not found" icon={<ErrorIcon />} />

      <Divider sx={{ m: 2 }} />

      <Grid container justifyContent="center">
        <Button href="/home" variant="contained" size="small">
          Home
        </Button>
      </Grid>
    </Grid>
  </ProtectedRoute>
);

export default NotFound;
